import React, {FunctionComponent} from 'react'
import {useTranslation} from 'react-i18next'

const Header: FunctionComponent = () => {
    const {t} = useTranslation()

    return <thead>
    <tr>
        <th className={'text-left'}>{t('First Name')}</th>
        <th className={'text-left'}>{t('Last Name')}</th>
        <th className={'text-right'}>{t('Totals')}</th>
    </tr>
    </thead>
}

export default Header
